module.exports = __webpack_public_path__ + "static/media/founder_irenebday.692dc702.png";